export default __webpack_public_path__ + "assets/images/1059c0152e8dc1e170294a199093c6d5.webp";